import React from 'react';
import { Typography, Box } from '@material-ui/core';

import { useStyles } from './styles';
import { OfferingHeaderDetailsProps } from './interface';

import { ReactComponent as TimeSVG } from './assets/time.svg';
import { ReactComponent as CalendarSVG } from './assets/calendar.svg';
import { getEventDate } from '../../../../utils/dateUtils';
import { getEventLabel } from '../../../../utils/event-type';

const OfferingHeaderDetails = ({ offering }: OfferingHeaderDetailsProps) => {
  const offeringDate = offering.sessions[0].startsAt;
  const classes = useStyles({});

  const formattedDate = getEventDate(offeringDate);

  const eventTypeLabel = getEventLabel(offering.type);

  return (
    <>
      <Typography variant="body1" className={classes.label}>
        {eventTypeLabel}
      </Typography>

      <Box className={classes.iconsContainer}>
        <Typography
          component="span"
          variant="body1"
          className={classes.iconWrapper}
        >
          <CalendarSVG className={classes.icon} />
        </Typography>
        <Typography
          component="span"
          variant="body1"
          style={{ fontWeight: 700 }}
          className={classes.iconLabel}
        >
          {formattedDate}
        </Typography>
        <Typography
          component="span"
          variant="body1"
          className={classes.iconWrapper}
        >
          <TimeSVG className={classes.icon} />
        </Typography>
        <Typography
          component="span"
          variant="body1"
          style={{ fontWeight: 700 }}
        >
          {`${offering.duration} mins`}
        </Typography>
      </Box>
    </>
  );
};

export default OfferingHeaderDetails;
